// User roles and what each may do. Mirrors backend/roles.py. Pure, no React.

export const ROLE_LABELS = {
  super_admin: 'Super Admin',
  admin: 'Admin',
  accounting: 'Accounting',
  sales_admin: 'Sales Admin',
  user: 'User',
  sales_rep: 'Sales Rep',
};

export const roleLabel = (role) => ROLE_LABELS[role] || role || 'User';

const roleOf = (user) => (user && user.role) || 'user';

export const isAdminRole = (user) => ['admin', 'super_admin'].includes(roleOf(user));

// Give a client to a rep, move it to another rep, or send it back to the pool.
export const canAssignClients = (user) =>
  isAdminRole(user) || ['accounting', 'sales_admin'].includes(roleOf(user));

// Who sees the Settings page at all (accounting only its own sections).
export const canAccessSettings = (user) =>
  isAdminRole(user) || roleOf(user) === 'accounting';
